import { executeGetRequest, executePostRequest, FetchConfig } from '@api/client';
import { createFetchDocumentPath, createValidateDocumentPath } from '@routing/apiUrls';
import { Document } from '@models/document/Document';
import { ValidateDocumentResponse } from '@models/ValidateDocument';

export const fetchDocument = async (documentId: number, editMode?: boolean, config?: FetchConfig) => {
    const result = await executeGetRequest<Document>(createFetchDocumentPath(documentId, editMode), config);
    return result.data;
};

export const validateDocument = async (documentId: number, actionId: string, config?: FetchConfig) => {
    const result = await executePostRequest<ValidateDocumentResponse>(createValidateDocumentPath(documentId, actionId), {}, config);
    return result.data;
};
